/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 5530e9d9f16302aae4fc5ca1aa601c3b */

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GuildEventsScreenQueryVariables = {
    id: string;
};
export type GuildEventsScreenQueryResponse = {
    readonly nodeBySlugId: ({
        readonly __typename: "Guild";
        readonly name: string;
        readonly upcomingEventsCount: {
            readonly totalCount: number;
        };
        readonly pastEventsCount: {
            readonly totalCount: number;
        };
        readonly " $fragmentRefs": FragmentRefs<"GuildMetadata_guild">;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
};
export type GuildEventsScreenQuery = {
    readonly response: GuildEventsScreenQueryResponse;
    readonly variables: GuildEventsScreenQueryVariables;
};



/*
query GuildEventsScreenQuery(
  $id: String!
) {
  nodeBySlugId(id: $id) {
    __typename
    ... on Guild {
      name
      ...GuildMetadata_guild
      upcomingEventsCount: eventsByTimeSelection(first: 1, timeSelection: UPCOMING, orderBy: [START_AT_DESC, ID_ASC]) {
        totalCount
      }
      pastEventsCount: eventsByTimeSelection(first: 1, timeSelection: PAST, orderBy: [START_AT_DESC, ID_ASC]) {
        totalCount
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment GuildMetadata_guild on Guild {
  slugId
  name
  description
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v5 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": [
    "START_AT_DESC",
    "ID_ASC"
  ]
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v7 = {
  "alias": "upcomingEventsCount",
  "args": [
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "kind": "Literal",
      "name": "timeSelection",
      "value": "UPCOMING"
    }
  ],
  "concreteType": "EventsConnection",
  "kind": "LinkedField",
  "name": "eventsByTimeSelection",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": "eventsByTimeSelection(first:1,orderBy:[\"START_AT_DESC\",\"ID_ASC\"],timeSelection:\"UPCOMING\")"
},
v8 = {
  "alias": "pastEventsCount",
  "args": [
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "kind": "Literal",
      "name": "timeSelection",
      "value": "PAST"
    }
  ],
  "concreteType": "EventsConnection",
  "kind": "LinkedField",
  "name": "eventsByTimeSelection",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": "eventsByTimeSelection(first:1,orderBy:[\"START_AT_DESC\",\"ID_ASC\"],timeSelection:\"PAST\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GuildEventsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildMetadata_guild"
              }
            ],
            "type": "Guild",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GuildEventsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slugId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "type": "Guild",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "29a8c8f2da0134aebaf40b56e0d58a02e30c4f99e3917c2e45bc3c4c73f4f769",
    "metadata": {},
    "name": "GuildEventsScreenQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
(node as any).hash = 'b5c2226484e8c3c54001326696121f63';
export default node;
